import { ClientHttpHeaders } from "@next-platform/packages-ts-types";
import basicAppConfig from "../constants/basicAppConfig";
import { NATIVE_PLATFORM } from "../constants/platform";
const getHeaders = (input = {}) => {
    const { userToken, guestUserId, country, applicationId, impersonateToken } = input;
    const headers = {};
    if (userToken) {
        headers[ClientHttpHeaders.AUTHORIZATION] = `Bearer ${userToken}`;
    }
    if (guestUserId) {
        headers[ClientHttpHeaders.GUEST_USER_ID] = guestUserId;
    }
    if (country) {
        headers[ClientHttpHeaders.COUNTRY] = country;
    }
    if (impersonateToken) {
        headers[ClientHttpHeaders.IMPERSONATE] = impersonateToken;
    }
    if (applicationId) {
        headers[ClientHttpHeaders.APP_ID] = applicationId;
    }
    if (basicAppConfig.appVersion) {
        headers[ClientHttpHeaders.APP_VERSION] = basicAppConfig.appVersion;
    }
    if (basicAppConfig.platform) {
        headers[ClientHttpHeaders.PLATFORM] = basicAppConfig.platform;
    }
    if (basicAppConfig.os) {
        headers[ClientHttpHeaders.PLATFORM_OS] = basicAppConfig.os;
    }
    // Native-only legacy header.
    if (basicAppConfig.platform === NATIVE_PLATFORM && applicationId && basicAppConfig.appVersion && basicAppConfig.os) {
        headers[ClientHttpHeaders.USER_AGENT] = `${applicationId}_${basicAppConfig.os.toLowerCase()}_${basicAppConfig.appVersion}`;
    }
    if (basicAppConfig.platform === NATIVE_PLATFORM && basicAppConfig.appVersion) {
        headers[ClientHttpHeaders.MOBILE_APP_VERSION] = basicAppConfig.appVersion;
    }
    return headers;
};
export default getHeaders;
